// Runs before any other import in main.tsx so transitive deps that use
// ES2019 features (notably tailwind-merge's createSortModifiers) don't
// crash on Chrome WebView 72 — the Facebook in-app browser on older
// Android. See Sentry issue JAVASCRIPT-REACT-G (2026-05-24).
if (typeof Object.fromEntries !== "function") {
  (
    Object as unknown as {
      fromEntries: (
        entries: ArrayLike<readonly [PropertyKey, unknown]>
      ) => Record<string, unknown>;
    }
  ).fromEntries = function fromEntries(entries) {
    if (entries == null) {
      throw new TypeError("Object.fromEntries requires an iterable argument");
    }
    const out: Record<string, unknown> = {};
    const len = entries.length;
    for (let i = 0; i < len; i++) {
      const entry = entries[i];
      out[String(entry[0])] = entry[1];
    }
    return out;
  };
}
